import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PatientComponent } from './patient.component';
import { PatientAddressComponent } from './patient-address/patient-address.component';
import { PatientAppointmentSummaryComponent } from './patient-appointment-summary/patient-appointment-summary.component';
import { PatientCommsComponent } from './patient-comms/patient-comms.component';
import { PatientContactsComponent } from './patient-contacts/patient-contacts.component';
import { PatientEditComponent } from './patient-edit/patient-edit.component';
import { PatientFindComponent } from './patient-find/patient-find.component';
import {ConfirmComponent} from '../../dialog/confirm-dialog/confirm.component';

const routes: Routes =
  [
      {
        path: '', component: PatientComponent,
        children:
            [
              { path: 'patient-address', component: PatientAddressComponent },
              { path: 'patient-appointment-summary', component: PatientAppointmentSummaryComponent },
              { path: 'patient-comms', component: PatientCommsComponent },
              { path: 'patient-contacts', component: PatientContactsComponent },
              { path: 'patient-edit', component: PatientEditComponent },
            { path: 'patient-find', component: PatientFindComponent },
            { path: 'patient-confirm', component: ConfirmComponent },
            ]
      }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
  })
export class PatientRoutingModule { }
